import { TranslationKeys } from './translation_types';

export class LanguageKeys implements TranslationKeys {
    [key: string]: string | Function;
  public LOGIN: string = "登入";
  public back: string = "返回";
  public login_title: string = "HealthScan";
  public login_subtitle: string = "登入您的帳戶";
  public username_label: string = "用戶名";
  public username_placeholder: string = "輸入用戶名";
  public password_label: string = "密碼";
  public password_placeholder: string = "輸入密碼";
  public sign_in: string = "登入";
  public invitation_subtitle: string = "輸入邀請碼以開始使用";
  public invitation_code_placeholder: string = "邀請碼";
  public verifying: string = "驗證中...";
  public scan_process_1: string = "請稍等，分析結果將在一分鐘內顯示...";
  public scan_process_2: string = "請避免移動頭部或說話";
  public scan_process_3: string = "測量期間請保持靜止";
  public scan_process_4: string = "請專注於螢幕";
  public scan_process_5: string = "溫馨提示:請與相機保持適當距離";
  public scan_process_6: string = "溫馨提示:避免逆光";
  public scan_process_7: string = "溫馨提示:請確保你的臉沒有被帽子、面具、頭髮等遮蓋";
  public scan_idle_tip: string = "請保持坐姿端正，確保臉部光線均勻，沒有背光。";
  public process_title: string = "免責聲明";
  public process_agree: string = "我已閱讀並接受上述條款";
  public process_msg1: string = "我們的手機應用程式是由PPG（光學脈搏測量）技術作為基礎計算，利用攝像鏡頭作健康檢查及健康數據分析。本應用程式旨在實現無接觸的身體檢查，並通過視頻捕捉收集生命體徵。在此聲名，本應用程式不會存儲任何人臉視頻或健康資料，所有數據僅作一次性健康評估之用。";
  public process_msg2: string = "我們需要強調的是，此健康檢查功能並不旨在取代醫學診斷或與任何專業醫療諮詢，它旨在初步評估並嘗試找出潛在健康問題。任何進一步的醫學建議或治療建議都應向合格的醫學專業人員尋求。";
  public process_msg3: string = "請注意，儘管我們致力於準確性，但該應用程式此不保證健康數據的準確性或完整性。我們建議使用者將應用程式提供的信息作為初步篩查工具，當有異常情況時，請盡快尋求專業醫學意見並進行全面的健康評估。您的健康是我們的首要關注。";
  public ok: string = "確定";
  public measurement_stopped: string = "測量已停止，請點擊開始按鈕重新啟動";
  public table_name: string = "名稱";
  public table_index: string = "數值";
  public table_confid: string = "置信度";
  public table_level: string = "等級";
  public table_normal: string = "正常範圍";
  public tab_wellness_score: string = "健康評分";
  public tab_wellness: string = "健康等級";
  public wellnessLevelValue: string = "健康評分";
  public tab_heart: string = "心臟健康";
  public tab_stress: string = "能量和壓力";
  public tab_vitals: string = "額外的生命徵象";
  public pulseRateValue: string = "心率";
  public bloodPressureValue: string = "血壓";
  public oxygenSaturationValue: string = "血氧飽和度";
  public respirationRateValue: string = "呼吸率";
  public hypertensionRiskValue: string = "高血壓風險";
  public highFastingGlucoseRiskValue: string = "空腹高血糖風險";
  public highTotalCholesterolRiskValue: string = "高總膽固醇風險";
  public highHbA1cRiskValue: string = "高糖化血紅素風險";
  public lowHemoglobinRiskValue: string = "低血紅素風險";
  public stressLevelValue: string = "壓力等級";
  public normalizedStressIndexValue: string = "標準壓力指數";
  public pnsZoneValue: string = "休息和消化等級";
  public snsZoneValue: string = "交感神經系統等級";
  public hemoglobinValue: string = "血紅素";
  public hemoglobinA1CValue: string = "糖化血紅素";
  public meanRriValue: string = "平均RRi";
  public rriValue: string  = "RRi";
  public rmssdValue: string = "RMSSD";
  public sd1Value: string = "SD1";
  public sd2Value: string = "SD2";
  public lfhfValue: string = "LF/HF";
  public prqValue:string = "PRQ";
  public loading: string = "載入中...";
  public error: string = "錯誤";
  public currentDateTime: string = "當前日期和時間";
  public invitation:string = "邀請碼";
  public invitationError:string = "邀請碼已過期";
  public submit:string = "提交";

  // 錯誤代碼翻譯
  public ERROR_4: string = "錯誤代碼[4], 設備處於「低功耗」模式，無法運行會話。";
  public ERROR_8: string = "錯誤代碼[8], 設備的操作系統版本低於運行 SDK 所需的最低版本。";
  public ERROR_14: string = "錯誤代碼[14], 電池電量低於 20%，無法進行精確測量。";
  public ERROR_17: string = "錯誤代碼[17], 檢測到嚴重的時鐘偏差。";
  public ERROR_19: string = "錯誤代碼[19], 藍牙已關閉。";
  public ERROR_20: string = "錯誤代碼[20], 應用程式沒有藍牙權限。";
  public ERROR_21: string = "錯誤代碼[21], 設備定位服務已關閉。";
  public ERROR_1001: string = "錯誤代碼[1001], 調用 session.start() 命令，但設備沒有符合規格的攝影機。";
  public ERROR_1002: string = "錯誤代碼[1002], 無法操作攝影機。";
  public ERROR_1005: string = "錯誤代碼[1005], 應用程式沒有存取攝影機的權限。";
  public ERROR_1501: string = "錯誤代碼[1501], 從攝影機接收的圖像解析度與請求的解析度不同。";
  public ERROR_2002: string = "錯誤代碼[2002], 您的授權不允許使用更多設備。";
  public ERROR_2003: string = "錯誤代碼[2003], 提供的授權不允許進行更多測量（僅適用於「按會話」授權的客戶）。";
  public ERROR_2004: string = "錯誤代碼[2004], 可能原因包括：檢測到時鐘偏差、SDK 無法驗證授權、從授權伺服器接收到無效的令牌。";
  public ERROR_2007: string = "錯誤代碼[2007], 提供的授權密鑰無效。";
  public ERROR_2010: string = "錯誤代碼[2010], 授權已被撤銷。";
  public ERROR_2016: string = "錯誤代碼[2016], SSL 錯誤，無法驗證授權伺服器回應。";
  public ERROR_2017: string = "錯誤代碼[2017], 授權已過期。";
  public ERROR_2018: string = "錯誤代碼[2018], 授權已被暫停。";
  public ERROR_2024: string = "錯誤代碼[2024], 無網路連線。";
  public ERROR_2025: string = "錯誤代碼[2025], SSL 證書安全警告。";
  public ERROR_2032: string = "錯誤代碼[2032], 未向 SDK 提供授權密鑰。";
  public ERROR_2034: string = "錯誤代碼[2034], 提供了無效的產品 ID。";
  public ERROR_2035: string = "錯誤代碼[2035], SDK 無法從檔案系統讀取，或檔案可能已損壞。";
  public ERROR_2036: string = "錯誤代碼[2036], SDK 無法按授權類型要求與授權伺服器進行身份驗證。";
  public ERROR_2037: string = "錯誤代碼[2037], SSL 證書安全警告。";
  public ERROR_2038: string = "錯誤代碼[2038], SSL 證書安全警告。";
  public ERROR_2039: string = "錯誤代碼[2039], SDK 版本太舊，無法與此授權一起使用。";
  public ERROR_2042: string = "錯誤代碼[2042], 單次調用達到網路超時。";
  public ERROR_2049: string = "錯誤代碼[2049], 此授權不包括使用跌倒檢測的權限。";
  public ERROR_3003: string = "錯誤代碼[3003], 多次檢測到超過 0.5 秒未識別到人臉。";
  public ERROR_3004: string = "錯誤代碼[3004], 測量期間檢測到超過 2 次的多幀丟失。";
  public ERROR_3006: string = "錯誤代碼[3006], 授權啟動失敗。";
  public ERROR_3008: string = "錯誤代碼[3008], 平均幀率顯著低於預期。";
  public ERROR_3009: string = "錯誤代碼[3009], 多次收到時間戳順序錯誤的連續幀。此錯誤在警告 3506 多次出現時發生。";
  public ERROR_3500: string = "錯誤代碼[3500], 超過 0.5 秒未檢測到人臉或手指。";
  public ERROR_3505: string = "錯誤代碼[3505], 攝影機 FPS 下降，可能影響測量質量。";
  public ERROR_3506: string = "錯誤代碼[3506], 收到時間戳順序錯誤的幀。";
  public ERROR_4505: string = "錯誤代碼[4505], 此次測量無法計算血壓。此警告不影響其他生命徵象測量。失敗可能是由損壞的安裝檔案引起。";
  public ERROR_4506: string = "錯誤代碼[4506], 此次測量未處理任何生命徵象。";
  public ERROR_6004: string = "錯誤代碼[6004], 在會話未處於 READY 狀態時調用會話開始。";
  public ERROR_6005: string = "錯誤代碼[6005], 在會話未處於 PROCESSING 狀態時調用會話停止。";
  public ERROR_7002: string = "錯誤代碼[7002], 創建會話時提供了無效的會話時間。";
  public ERROR_7004: string = "錯誤代碼[7004], 創建會話時同時使用了 withImageRotation 和 TatarOrientation 屬性。";
  public ERROR_7005: string = "錯誤代碼[7005], 提供的授權密鑰為空或格式無效。";
  public ERROR_7006: string = "錯誤代碼[7006], SDK 初始化失敗，可能是因為硬體不受支持。";
  public ERROR_7007: string = "錯誤代碼[7007], 用戶提交的體重不受支持。支持的體重範圍為 40 至 200 公斤。";
  public ERROR_7008: string = "錯誤代碼[7008], 用戶提交的年齡不受支持。支持的年齡範圍為 18 至 110 歲。";
  public ERROR_7009: string = "錯誤代碼[7009], 在終止前一個會話之前嘗試創建新會話。請重新啟動應用程式。";
  public ERROR_7010: string = "錯誤代碼[7010], 應用程式的 build.gradle 檔案中缺少 Polar SDK 依賴。";
  public ERROR_7011: string = "錯誤代碼[7011], 應用程式指示使用 SDK 內的分析功能，但應用程式的 build.gradle 檔案中未包含 Segment Analytics-Kotlin 依賴。";
  public ERROR_7012: string = "錯誤代碼[7012], 用戶提交的身高不受支持。支持的身高範圍為 130 至 230 厘米。";
  public ERROR_7015: string = "錯誤代碼[7015], 指示用戶升級瀏覽器版本或使用其他瀏覽器/設備。";
  public ERROR_8003: string = "錯誤代碼[8003], 藍牙設備回應連接請求的時間過長。";
  public ERROR_8004: string = "錯誤代碼[8004], 請求的藍牙設備 ID 格式無效。";
  public ERROR_8005: string = "錯誤代碼[8005], 藍牙設備的固件版本不受支持。";
  public ERROR_8006: string = "錯誤代碼[8006], 藍牙設備的硬體不受支持。";
  public ERROR_8007: string = "錯誤代碼[8007], 藍牙設備已斷開連接。";
  public ERROR_8008: string = "錯誤代碼[8008], 傳感器放置錯誤、被移除或未固定在皮膚上。";
  public ERROR_9001: string = "錯誤代碼[9001], 此會話的跌倒檢測監控暫時停止。";
  public ERROR_9500: string = "錯誤代碼[9500], PPG 設備的數據流中丟失了一些數據，可能影響 SDK 準確監控用戶的能力。";

  public ERROR_10000: string = "圖像有效性問題。";
  public ERROR_10001: string = "方向錯誤。";
  public ERROR_10002: string = "未檢測到人臉。";
  public ERROR_10003: string = "頭部姿勢傾斜。";
  public ERROR_10004: string = "你太遠了。";
  public ERROR_10005: string = "光線不平均。";
  public ERROR_10006: string = "請將手機轉向正確方向。";
  public ERROR_10007: string = "請將相機對準您的臉部，並確保距離適中。";
  public ERROR_10008: string = "請保持頭部垂直。";
  public ERROR_10009: string = "請將臉靠近相機。";
  public ERROR_10010: string = "請確保您的背景亮度適中。";
}

export default LanguageKeys;